import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { IdentityStore } from '../stores/IdentityStore';
import { LanguageStore } from '../../../../core/stores/LanguageStore';
import { environment } from '../../../../../environments/environment';

export const noAuthGuard: CanActivateFn = (route, state) => {
  if (inject(IdentityStore).identity()) {
    const languageStore = inject(LanguageStore);

    inject(Router).navigateByUrl(`/${languageStore.language().key || environment.fallbackLanguage}/dashboard`);

    return false;
  }

  return true;
};
